import { createSlice } from "@reduxjs/toolkit";
import { fetchTeacherCourseData } from "./teacherCourseDataThunk";

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: null,
};

export const teacherCourseDataSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTeacherCourseData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTeacherCourseData.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(fetchTeacherCourseData.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.success = false;
    });
  },
});

export default teacherCourseDataSlice.reducer;
